import React from "react";
import URL from "./url";

const APIURL = `${URL}/api`;

export default APIURL;
